/**
 * Notification system component for PinnedClientsList
 * Handles notification toast display and management
 */

import React from 'react';
import '../../../styles/components/clients/pinned-list/PinnedListNotifications.css';

/**
 * PinnedListNotifications component
 * @param {Object} props - Component props
 * @param {boolean} props.showNotification - Whether to show the notification
 * @param {string} props.notificationMessage - Message to display in notification
 * @param {Function} props.onClose - Function to close the notification
 * @returns {JSX.Element|null} Notification component or null if not showing
 */
const PinnedListNotifications = ({ 
  showNotification, 
  notificationMessage, 
  onClose 
}) => {
  if (!showNotification) {
    return null;
  }

  return (
    <div className="pinned-clients-list__notification-toast">
      <span>{notificationMessage}</span>
      <button 
        onClick={onClose}
        className="pinned-clients-list__notification-close"
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

export default PinnedListNotifications;
